import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {},
  mainBackgroundImage: {
    overflow: 'auto',
  },
  contentContainer: {
    position: 'relative',
    flexDirection: 'column',
    maxWidth: '1360px',
    width: '100%',
    marginY: ['60px', '97px'],
    marginX: 'auto',
  },
  tabsContentContainer: {
    background: '#FFF',
    border: '1px solid rgba(0, 0, 0, 0.5)',
    borderTop: 'none',
    position: 'relative',
  },
  descriptionContainer: {
    position: 'absolute',
    transition: 'opacity 1s cubic-bezier(0.4, 0.0, 0.2, 1)',
    width: '100%',
    paddingRight: '60px',
    top: ['20px', '60px'],
  },
  tabsContainer: {
    flexDirection: ['column', 'column', 'row'],
    alignItems: 'baseline',
    order: ['1', '1', '0'],
  },
  tabsTitleContainer: {},
  tabsContentImageContainer: {
    minHeight: ['772px', '972px', '812px'],
    backgroundSize: 'contain',
    display: ['none', 'none', 'block'],
    backgroundPosition: 'bottom',
    backgroundRepeat: 'no-repeat',
  },
  tabsContentMobileImageContainer: {
    minHeight: ['772px', '972px', '812px'],
    backgroundSize: 'contain',
    display: ['block', 'block', 'none'],
    backgroundPosition: 'bottom',
    backgroundRepeat: 'no-repeat',
  },
  tabTitle: {
    background: '#8086F2',
    border: '1px solid rgba(0, 0, 0, 0.5)',
    borderBottom: ['none'],
    textAlign: 'center',
    marginRight: '5px',
    transition: 'padding, color, background 1s cubic-bezier(0.4, 0.0, 0.2, 1)',
    width: ['100%', '100%', '210px'],
    '&:hover': {
      cursor: 'pointer',
    },
  },
  activeTab: {
    border: '1px solid rgba(0, 0, 0, 0.5)',
    borderBottom: 'none',
    color: 'black',
    background: '#FFF',
    padding: '20px 0 20px',
    textAlign: 'center',
    alignItems: 'center',
    display: ['block', 'block', 'none'],
  },
  tabTitleContainer: {
    color: '#FFF',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    height: ['130px'],
    marginX: ['30px', '30px', '0'],
  },
  descriptionTitle: {
    padding: '0 0 25px',
  },
  desCriptionTitleContainer: {
    marginX: '20px',
  },
};
